import React from 'react'
import OverlinedSmall from '../atoms/OverlinedSmall'

type Props = {
  children: React.ReactNode
  from: string | React.ReactElement
}

const Quote = ({ children, from }: Props) => {
  return (
    <div className="flex flex-col items-center col-span-2">
      <div className="px-8 pb-8 xl:w-10/12 text-xl leading-loose text-center lg:text-4xl lg:leading-relaxed">
        <span className="text-2xl lg:text-5xl lg:leading-relaxed leading-loose font-medium pr-1">
          &ldquo;
        </span>
        {children}
        <span className="text-2xl lg:text-5xl lg:leading-relaxed leading-loose font-medium pl-1">
          &rdquo;
        </span>
      </div>
      <OverlinedSmall>{from}</OverlinedSmall>
    </div>
  )
}

export default Quote
